var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinances(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33331 16.3333C2.33331 11.9336 2.33331 9.73367 3.70015 8.36684C5.06698 7 7.26687 7 11.6666 7H16.3333C20.7331 7 22.933 7 24.2998 8.36684C25.6666 9.73367 25.6666 11.9336 25.6666 16.3333C25.6666 20.7331 25.6666 22.933 24.2998 24.2998C22.933 25.6667 20.7331 25.6667 16.3333 25.6667H11.6666C7.26687 25.6667 5.06698 25.6667 3.70015 24.2998C2.33331 22.933 2.33331 20.7331 2.33331 16.3333Z",
    stroke: "#939CB4",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M18.6666 6.99992C18.6666 4.80003 18.6666 3.70009 17.9832 3.01667C17.2998 2.33325 16.1999 2.33325 14 2.33325C11.8001 2.33325 10.7001 2.33325 10.0167 3.01667C9.33331 3.70009 9.33331 4.80003 9.33331 6.99992",
    stroke: "#939CB4",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M14 20.2223C15.2887 20.2223 16.3334 19.3517 16.3334 18.2779C16.3334 17.204 15.2887 16.3334 14 16.3334C12.7114 16.3334 11.6667 15.4629 11.6667 14.389C11.6667 13.3151 12.7114 12.4445 14 12.4445M14 20.2223C12.7114 20.2223 11.6667 19.3517 11.6667 18.2779M14 20.2223V21.0001M14 11.6667V12.4445M14 12.4445C15.2887 12.4445 16.3334 13.3151 16.3334 14.389",
    stroke: "#939CB4",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinances);
export default __webpack_public_path__ + "static/media/finances.33d8abdbb54212b6691ade24957710a6.svg";
export { ForwardRef as ReactComponent };